import axios from 'axios';
import { TOKEN } from './Constants';

export const _setDataToStorage = async (key, data) => {
  localStorage.setItem(key, data);
};

export const clearStorageData = (key) => {
  localStorage.removeItem(key);
};

export const getValueIntoStorage = (key) => {
  try {
    const value = localStorage.getItem(key);
    if (value !== null) {
      return value;
    }
    return null;
  } catch (error) {
    return null;
  }
};

export const getTokenAndSetIntoHeaders = (token) => {
  if (token) {
    axios.defaults.headers.common.Authorization = token;
  } else {
    const storageToken = getValueIntoStorage(TOKEN);
    if (storageToken) {
      axios.defaults.headers.common.Authorization = storageToken;
    }
  }
};
export const clearHeaders = (token) => {
  if (token) {
    axios.defaults.headers.common.Authorization = '';
  } else {
    const storageToken = getValueIntoStorage(TOKEN);
    if (storageToken) {
      axios.defaults.headers.common.Authorization = '';
    }
  }
};
